export class UserRoleModel {
  id: number;
  role: string;
}
